window.$ = window.jQuery = require('jquery');
import './bootstrap.bundle.min.js' ;
import './mega-menu.js' ;
import './owl.carousel.min.js' ;
import './select2.min.js' ;
import '../GlobalFile/jquery.fancybox.min.js' ;
import '../GlobalFile/Slider/jssor.slider-27.5.0.min.js' ;
import '../GlobalFile/datepicker/jquery.cookie.min.js' ;
import '../GlobalFile/datepicker/jquery.ui.core.js' ;
import '../GlobalFile/datepicker/jquery.ui.datepicker-cc.js' ;
import '../GlobalFile/datepicker/datepicker-scripts.js' ;
import '../GlobalFile/datepicker/datepicker-declarations.js' ;
import '../GlobalFile/plugins/popper.min.js' ;
import '../GlobalFile/plugins/bootstrap-select.min.js' ;
import '../GlobalFile/easy_responsive_tabs/easyResponsiveTabs.js' ;
import '../GlobalFile/rate/rater.js' ;
import '../GlobalFile/plugins/bootstrap-notify.js' ;
import '../GlobalFile/plugins/jquery.validate.min.js' ;
import '../GlobalFile/plugins/bs-custom-file-input.min.js' ;
import './script.js' ;